<template>
  <v-app id="app">
    <v-navigation-drawer fixed clipped app v-model="drawer" :class="['elevation-12']">
      <navigation-bar :items="icons" />
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left dark :color="primaryColor" dense>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title v-html="siteTitle" />
      <v-spacer />
      <v-btn icon ripple router to="/" title="Home">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn
        icon
        ripple
        target="_blank"
        v-for="(link, index) in $store.state.meta.links" :key="index"
        :href="link.href"
        :title="link.title">
        <v-icon v-html="link.icon" />
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container>
        <router-view />
      </v-container>
    </v-content>
    <v-footer app>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-right">
            &copy; {{ year }} <a href="https://wemakesites.net" target="_blank">Martin Ivanov</a>
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
    <social-bar />
    <cookie-consent-bar
      ok="Dismiss"
      view="Policy"
      days="14"
      page="cookies"
      :cookie="$store.state.consentCookieName"
      message="I use cookies to ensure you get the best experience" />
  </v-app>
</template>
<script>
import NavigationBar from './components/navigation-bar'
import SocialBar from './components/social-bar'
import CookieConsentBar from './components/cookie-consent-bar'

export default {
  name: 'App',
  components: {
    NavigationBar,
    SocialBar,
    CookieConsentBar
  },
  data () {
    return {
      drawer: null,
      icons: [],
      primaryColor: this.$store.state.primaryColor || '',
      meta: this.$store.state.meta,
      siteTitle: this.$store.state.meta.siteTitle,
      year: new Date().getFullYear()
    }
  },
  created () {
    this.icons = this.$store.getters.icons
  }
}
</script>
<style>
body
{
  cursor: default;
}

.no-bullet-list
{
  list-style: none;
}
.inline-list li
{
  display: inline-block;
  vertical-align: middle;
}

.icons-list
{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.icons-list li
{
  width: 25%;
  text-align: center;
  cursor: pointer;
}

.icons-list i
{
  font-size: 32px;
}

footer a,
.page-content a,
.navigation-drawer p a,
.navigation-drawer .list .list__tile--active,
.navigation-drawer .list .list__tile--active .icon
{
  color: #e44b27 !important;
}

[hidden]
{
  display: none;
}

p
{
  color: #757575;
}

@media all and (max-width: 600px) {
  .icons-list li
  {
    width: 33.3333%;
  }
}

@media all and (max-width: 500px) {
  .icons-list li
  {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue